import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { CheckBox } from "../../components/Input";
// import './LeaveTypeForm.css'; // Import your CSS styles

const LeaveTypeForm = ({ leaveType, id, pageSave, pageBack }) => {
  const [formData, setFormData] = useState({
    type: "",
    description: "",
    yearly_leave: "",
    monthly_leave: "",
    is_loss_of_pay: false,
  });

  const [operation, setOperation] = useState("Add");

  useEffect(() => {
    if (id) {
      setOperation("Edit");
      setFormData({
        type: leaveType.type || "",
        description: leaveType.description || "",
        yearly_leave: leaveType.yearly_leave || "",
        monthly_leave: leaveType.monthly_leave || "",
        is_loss_of_pay: leaveType.is_loss_of_pay === 1,
      });
    }
  }, [id, leaveType]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Perform save action here
    console.log(formData);
    // You can use an API call to save the data
    Swal.fire(
      "Success",
      `${operation} Leave Type successfully!`,
      "success"
    ).then(() => {
      window.location.href = pageBack; // Redirect after submission
    });
  };

  return (
    <div
      id="page-container"
      className="page-header-fixed page-sidebar-fixed fade in"
    >
      <div id="content" className="">
        <div className="panel panel-default with-rounded-corner with-shadow">
          <form onSubmit={handleSubmit} className="stdform">
            <input type="hidden" name="id" value={id} />
            <div className="panel-heading border-0">
              <span className="panel-title">{operation} Leave Type</span>
            </div>
            <div className="panel-body">
              <div className="row">
                <div className="col-md-4">
                  <div className="form-group">
                    <label>Type</label>
                    <input
                      type="text"
                      name="type"
                      className="form-control"
                      placeholder="Enter Type"
                      value={formData.type}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Description</label>
                    <textarea
                      name="description"
                      className="form-control"
                      placeholder="Enter Description"
                      value={formData.description}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Yearly Leave</label>
                    <input
                      type="number"
                      name="yearly_leave"
                      className="form-control"
                      placeholder="Enter Yearly Leave"
                      value={formData.yearly_leave}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Monthly Leave</label>
                    <input
                      type="number"
                      name="monthly_leave"
                      className="form-control"
                      placeholder="Enter Monthly Leave"
                      value={formData.monthly_leave}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <CheckBox
                      label="Is Loss Of Pay"
                      fieldname="is_loss_of_pay"
                      checked={formData.is_loss_of_pay}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="form-group">
                    <button
                      type="button"
                      className="btn btn-default"
                      onClick={() => (window.location.href = pageBack)}
                    >
                      Back
                    </button>
                    <button type="submit" className="btn btn-primary">
                      {operation} Leave Type
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <a href="#" data-click="scroll-top" className="btn-scroll-top fade">
          <i className="ti-arrow-up"></i>
        </a>
      </div>
    </div>
  );
};

export default LeaveTypeForm;
